
import { GridComponent as EjsGrid, ColumnsDirective as EColumns, ColumnDirective as EColumn, Resize, Toolbar, Search, CommandColumn, Page, Group, Sort, Freeze }
  from '@syncfusion/ej2-vue-grids';
import { defineComponent } from 'vue';
import modal from '@/components/common/modalManage';
import agent, { fortnoxServiceBaseURL } from '@/services/agent';
import toasterService from '@/services/toasterService';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import { DatePickerComponent } from '@syncfusion/ej2-vue-calendars';
import { Company, CompanyGetResponse, CompanyResponse, EntityLookUp, ForceSyncForm, FortnoxActivationResponse, GetCompanyWiseEntitiesResponse, PostCompany, Property, SyncResponse } from './Company.model';
import preLoader from '@/services/preLoader';
import { hasFortnox } from '@/shared/app.util';
import { useUserStore } from '@/store/useUserStore';
import { DialogUtility } from '@syncfusion/ej2-vue-popups';
import moment from 'moment';
import { CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-vue-buttons';
import { CheckBoxSelection, MultiSelectComponent } from '@syncfusion/ej2-vue-dropdowns';
import { loadLegalEntity } from '@/components/finance/common/CommonService';
import { LookUpModel } from '@/components/finance/common/ResponseModel';
import CustomTreeView from '@/components/shared/treeview/CustomTreeView.vue';
import CardTitleComponent from "@/components/common/CardTitleComponent.vue";
import SearchComponent from '@/components/shared/SearchComponent.vue';
import './CompanyComponent.css';
import { TextBoxComponent } from '@syncfusion/ej2-vue-inputs';
import _ from 'lodash';
import appInsights from '@/services/appInsights';

let _companyData: Property = {} as Property;
let _companyForm: PostCompany = {
  id: 0,
  organizationNumber: '',
  name: '',
  scope: '',
  entitiesSelectedForSync: '',
  doSync: false,
  legalEntityId: 0,
  createLegalEntity: false,
};
let Confirmation: any;

export default defineComponent({
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    "ejs-grid": EjsGrid,
    "e-columns": EColumns,
    "e-column": EColumn,
    CustomTreeView,
    DatePickerComponent,
    "ejs-checkbox": CheckBoxComponent,
    "ejs-radiobutton": RadioButtonComponent,
    "ejs-multiselect": MultiSelectComponent,
    CardTitleComponent,
    SearchComponent,
    'ejs-textbox': TextBoxComponent,
  },
  provide: {
    grid: [Toolbar, Resize, Search, CommandColumn, Page, Sort, Group, Freeze],
    multiselect: [CheckBoxSelection]
  },
  created() {
    agent.setBaseUrl(fortnoxServiceBaseURL);
    this.gridLocalize();
  },
  data() {
    return {
      data: _companyData,
      form: _companyForm as PostCompany,
      formKey: 0,
      isUpdate: false,
      isTableLoad: false,
      selectedState: null,
      searchOptions: { fields: ['Name', 'CreationTime', 'RefreshTokenExpireDate', 'LastSyncDate'], operator: 'contains', ignoreCase: true },
      toolbar: ['Search'],
      pageSettings: {
        pageSizes: [10, 20, 50, 100],
        pageSize: 50,
        pageCount: 5,
        skip: 0,
        take: 50
      },
      commands: [
        { type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
        { type: 'Delete', buttonOption: { cssClass: 'e-flat', iconCss: 'e-delete e-icons' } },
        { type: 'Force Fortnox Sync', buttonOption: { cssClass: 'e-flat force-sync', iconCss: 'e-repeat e-icons' } },
        { type: 'Fortnox Activation', buttonOption: { cssClass: 'e-flat', iconCss: 'e-plus e-icons' } },
      ],
      locale: '',
      forceSync: {
        date: null,
        companyId: 0,
        type: 'full',
        subscriptionId: '',
        isSpecificEntities: false,
        entities: [] as number[],
      } as ForceSyncForm,
      today: new Date(),
      defaultTreeViewOptions: [
        "archive",
        "settings",
        "costcenter",
        "invoice",
        "customer",
        "bookkeeping",
        "project",
        "article",
        "payment",
        "connectfile",
        "supplier",
        "supplierinvoice",
        "Employee"
      ],
      treeViewData: [
        //{ id: 'companyinformation', text: 'Company Information', hasChild: true },
        //{ id: 'CompanySetting', pid: 'companyinformation', text: 'Company Information' },
        { id: 'archive', text: 'Archive (Any)', hasChild: true },
        { id: 'DownloadArchiveFiles', pid: 'archive', text: 'Download Archive Files' },

        // { id: 'inbox', text: 'Inbox (Any)', hasChild: true },
        // { id: 'DownloadInboxFiles', pid: 'inbox', text: 'Download Inbox Files' },

        { id: 'settings', text: 'Settings (Any)', hasChild: true },
        { id: 'Unit', pid: 'settings', text: 'Units' },
        { id: 'CompanySetting', pid: 'settings', text: 'Company Settings' },
        { id: 'LockedPeriod', pid: 'settings', text: 'Locked Period' },

        { id: 'costcenter', text: 'Cost Center', hasChild: true },
        { id: 'CostCenter', pid: 'costcenter', text: 'Cost Center' },

        { id: 'invoice', text: 'Invoice (Order or Kundfaktura)', hasChild: true },
        { id: 'ContractAccrualHead', pid: 'invoice', text: 'Contract Accruals' },
        { id: 'ContractTemplate', pid: 'invoice', text: 'Contract Templates' },
        { id: 'Contract', pid: 'invoice', text: 'Contracts' },
        { id: 'InvoiceAccrual', pid: 'invoice', text: 'Invoice Accruals' },
        { id: 'InvoiceHead', pid: 'invoice', text: 'Invoices' },

        { id: 'customer', text: 'Customer (Order or Kundfaktura)', hasChild: true },
        { id: 'Customer', pid: 'customer', text: 'Customers' },

        { id: 'bookkeeping', text: 'Bookkeeping (Bokföring or Kundfaktura)', hasChild: true },
        { id: 'VoucherHead', pid: 'bookkeeping', text: 'Vouchers' },
        { id: 'AccountList', pid: 'bookkeeping', text: 'Accounts' },
        { id: 'AccountChart', pid: 'bookkeeping', text: 'Account Charts' },
        { id: 'FinancialYear', pid: 'bookkeeping', text: 'Financial Years' },

        { id: 'project', text: 'Project (Bokföring or Order or Kundfaktura)', hasChild: true },
        { id: 'Project', pid: 'project', text: 'Projects' },

        { id: 'article', text: 'Article (Order or Kundfaktura)', hasChild: true },
        { id: 'Article', pid: 'article', text: 'Article' },

        { id: 'price', text: 'Price (Order or Kundfaktura)', hasChild: true },
        { id: 'PriceList', pid: 'price', text: 'Price Lists' },
        { id: 'Prices', pid: 'price', text: 'Prices' },

        { id: 'payment', text: 'Payment (Bokföring or Order or Kundfaktura)', hasChild: true },
        { id: 'InvoicePayment', pid: 'payment', text: 'Invoice Payments' },
        { id: 'SupplierInvoicePayment', pid: 'payment', text: 'Supplier Invoice Payments' },


        { id: 'connectfile', text: 'Connect File', hasChild: true },
        { id: 'ArticleFileConnection', pid: 'connectfile', text: 'Article File Connections' },
        { id: 'SupplierFileConnection', pid: 'connectfile', text: 'Supplier Invoice File Connections' },

        { id: 'supplier', text: 'Supplier (Bokföring)', hasChild: true },
        { id: 'Supplier', pid: 'supplier', text: 'Suppliers' },

        { id: 'supplierinvoice', text: 'Supplier Invoice (Bokföring)', hasChild: true },
        { id: 'SupplierInvoice', pid: 'supplierinvoice', text: 'Supplier Invoices' },
        { id: 'SupplierInvoiceExternalUrlConnection', pid: 'supplierinvoice', text: 'Supplier Invoice External URL Connections' },
        { id: 'SupplierInvoiceAccrual', pid: 'supplierinvoice', text: 'Supplier Invoice Accruals' },

        { id: 'order', text: 'Order (Order)', hasChild: true },
        { id: 'Order', pid: 'order', text: 'Orders' },

        { id: 'salary', text: 'Salary (Lön)', hasChild: true },
        { id: 'AbsenceTransaction', pid: 'salary', text: 'Absence transactions' },
        { id: 'AttendanceTransaction', pid: 'salary', text: 'Attendance transactions' },
        { id: 'Employee', pid: 'salary', text: 'Employees' },
        { id: 'Expense', pid: 'salary', text: 'Expenses' },
        { id: 'SalaryTransaction', pid: 'salary', text: 'Salary transactions' },
        { id: 'ScheduleTime', pid: 'salary', text: 'Schedule times' },

        { id: 'assets', text: 'Assets (Anläggningsregister)', hasChild: true },
        { id: 'Asset', pid: 'assets', text: 'Assets' },

        { id: 'currency', text: 'Currency (Bokföring or Order or Kundfaktura)', hasChild: true },
        { id: 'Currency', pid: 'currency', text: 'Currencies' },

        { id: 'offer', text: 'Offer (Order)', hasChild: true },
        { id: 'Offer', pid: 'offer', text: 'Offers' },
      ],
      scopeTreeSelectedNodes: Array<string>(),
      alert: {
        show: false,
        messages: [] as string[]
      },
      entityLookUp: {
        data: [] as EntityLookUp[],
        fields: { value: "id", text: "name" },
      },
      legalEntities: [] as LookUpModel[],
      disabledNodes: [] as string[],
      searchText: '',
    }
  },
  async mounted() {
    preLoader.hide();
    if (location.search) {
      this.activateFortnox();
    } else {
      await this.getLegalEntities();
      this.dataStateChange(this.initState(this.pageSettings.skip, this.pageSettings.take));
    }
  },
  computed: {
    hasLegacyCompanies(): boolean {
      if (!this.data || !this.data.result) return false;
      return this.data.result.some((item: Company) => !item.tenantId && !item.isTokenMissing);
    },
  },
  methods: {
    async getLegalEntities() {
      const data = await loadLegalEntity();
      this.legalEntities = data;
    },
    initState(skip: number = 0, take: number): any {
      let state = {
        skip: skip,
        take: take
      };
      return state;
    },
    split(url: string) {
      let regex = /[?&]([^=#]+)=([^&#]*)/g;
      let params = [];
      let match;

      while ((match = regex.exec(url))) {
        const paramName = decodeURIComponent(match[1]);

        const paramValue = decodeURIComponent(match[2]);

        params.push({ paramName: paramName, value: paramValue });
      }
      // Need to handle scenario when code, state or sid is missing in query string to avoid error in API call and show proper message to user. Currently assuming all are present as they are expected from Fortnox after authentication.
      let sid = params.find((x) => x.paramName.indexOf("sid") > -1)?.value;
      let code = params.find((x) => x.paramName.indexOf("code") > -1)?.value;
      let state = params.find((x) => x.paramName.indexOf("state") > -1)?.value;

      if (!code || !state) {
        let error = params.find((x) => x.paramName.indexOf("error") > -1)?.value;
        let errorDescription = params.find((x) => x.paramName.indexOf("error_description") > -1)?.value;

        // if (error && errorDescription) {
        //   toasterService.error(`Fortnox authentication failed: ${errorDescription}`);
        // } else {
        //   toasterService.error('Cannot get code from Fortnox. Please contact support.');
        // }
        let payload = { isSuccess: false, error, errorDescription };
        return payload;
      }

      let payload = { isSuccess: true, code, state, sid };
      return payload;
    },
    dataStateChange(state: any) {
      this.pageSettings.skip = state.skip;
      this.pageSettings.take = state.take;
      this.gridLocalize();
      this.loadCompany(state);
    },
    loadCompany(state: any) {
      if (state.action) {
        delete state.action;
      }

      const gridCompany: any = this.$refs.gridCompany;
      if (gridCompany) {
        gridCompany.hideSpinner();
      }
      agent
        .post<CompanyGetResponse>(`v1/company/getcompany`, { ...state })
        .then((response) => {
          if (response.result) {
            this.data = _.cloneDeep(response.result);
            this.showAlert();
          }
        })
        .catch(() => { });
    },
    onUpsert(event: any) {
      event.preventDefault();
      if (!this.form.createLegalEntity && (!this.form.legalEntityId || this.form.legalEntityId <= 0)) {
        toasterService.error('Please select legal entity');
        return;
      }
      if (this.isUpdate) {
        this.onEdit();
      } else {
        this.onSave();
      }
    },

    getSelectedNodes(): Array<string> {
      return this.scopeTreeSelectedNodes;
    },
    getAllScopes() {
      return this.treeViewData.filter(node => node.hasChild).map(node => node.id);
    },
    prepareScopeAndEntities() {
      const scopeList = this.getAllScopes();
      const selectedNodes = this.getSelectedNodes();

      const selectedEntities = selectedNodes.filter(node => !scopeList.includes(node)) ?? [];
      const selectedScopes = selectedEntities.map(entity => this.treeViewData.find(node => node.id === entity)?.pid) ?? [];

      // 
      const spaceSeparatedScopes = [...new Set(selectedScopes)].join(' ');
      const spaceSeparatedEntities = selectedEntities.join(' ');

      return { spaceSeparatedScopes, spaceSeparatedEntities };
    },

    onSave() {
      const { spaceSeparatedScopes, spaceSeparatedEntities } = this.prepareScopeAndEntities();

      if (!spaceSeparatedScopes || !spaceSeparatedEntities) {
        toasterService.warn('Please select scopes or entities');
        return;
      }

      let post = {
        ...this.form,
        legalEntityId: this.form.createLegalEntity ? 0 : this.form.legalEntityId,
        scope: spaceSeparatedScopes,
        entitiesSelectedForSync: spaceSeparatedEntities,
        isScopeChangeApplied: false
      };

      agent.post<CompanyResponse>(`v1/company`, post).then((response) => {
        if (response.result) {
          toasterService.success(this.$t("msgSave"));
          this.loadCompany(this.initState(this.pageSettings.skip, this.pageSettings.take));
          if (this.form.createLegalEntity) {
            this.getLegalEntities();
          }
          this.close();
        }
      }).catch(() => { });
    },
    onEdit() {
      const { spaceSeparatedScopes, spaceSeparatedEntities } = this.prepareScopeAndEntities();

      // Check if scope is changed, then only mark token need to regenerate
      // false -> token needs to be regenerated with updated scopes
      // true -> token doesn't need to be regenerated
      //const isScopeChanged = this.checkScopeChanged(this.form.scope, spaceSeparatedScopes);
      //this.form.isScopeChangeApplied = isScopeChanged ? false : true;

      let put = { ...this.form, scope: spaceSeparatedScopes, entitiesSelectedForSync: spaceSeparatedEntities };

      agent.put<CompanyResponse>(`v1/company`, put).then((response) => {
        if (response.result) {
          toasterService.success(this.$t("msgUpdate"));
          this.loadCompany(this.initState(this.pageSettings.skip, this.pageSettings.take));
          this.close();
        }
      }).catch(() => { });
    },
    onDelete() {
      let put = { ...this.form };

      agent.delete<CompanyResponse>(`v1/company/${put.id}`, {}).then((response) => {
        if (response.result) {
          toasterService.success(this.$t("msgDelete"));
          this.resetCompany();
          this.loadCompany(this.initState(this.pageSettings.skip, this.pageSettings.take));

        }
      }).catch(() => { });
    },
    resetCompany() {
      this.form = {
        id: 0,
        organizationNumber: '',
        name: '',
        createLegalEntity: false,
        legalEntityId: 0,
        scope: '',
        entitiesSelectedForSync: '',
        doSync: false,
      } as PostCompany;

      // let legalEntityDropDown: any = this.$refs.legalEntityDropDown;
      // if (legalEntityDropDown) {
      //   legalEntityDropDown.clear();

      // }
      this.isUpdate = false;
    },
    gridLocalize() {
      this.locale = 'en-grid';
      if (this.$i18n.locale == 'se') {
        setTimeout(() => {
          import(`@/assets/sv.json`).then(module => {
            const localText = module.default;
            this.locale = 'sv';
            setCulture('sv');
            L10n.load(localText);
          });
        });
      }
    },
    onEditButtonClick(row: any) {
      this.commandClick({ commandColumn: { type: 'Edit' }, rowData: row },);
    },

    onDeleteButtonClick(row: any) {
      this.commandClick({ commandColumn: { type: 'Delete' }, rowData: row },);
    },
    onForceSyncButtonClick(row: any) {
      this.commandClick({ commandColumn: { type: 'Force Fortnox Sync' }, rowData: row },);
    },
    onActivateFortnoxButtonClick(row: any) {
      this.commandClick({ commandColumn: { type: 'Authenticate Fortnox' }, rowData: row },);
    },
    commandClick: function (args: { commandColumn: any, rowData: Company }) {
      this.isUpdate = false;
      const app = this;
      if (args) {
        switch (args.commandColumn.type) {
          case 'Delete':
            this.form.id = args.rowData.id;
            Confirmation = DialogUtility.confirm({
              title: this.$t("deleteConfiramtion"),
              content: this.$t("msgSureAllDataWithCompany"),
              okButton: {
                text: this.$t("ok"),
                click: async function () {
                  Confirmation.hide();
                  app.onDelete();
                },
              },
              cancelButton: { text: this.$t("cancel") },
              showCloseIcon: true,
              closeOnEscape: true,
              zIndex: 10000,
              animationSettings: { effect: "Zoom" },
            });
            break;
          case 'Edit':
            this.form = _.cloneDeep(args.rowData);
            this.isUpdate = true;
            this.prepareCompanyModalEditView();
            modal.Open('companyModal');
            this.disableTreeViewNodes();
            break;
          case 'Force Fortnox Sync':
            this.forceSync.companyId = args.rowData.id;
            this.forceSync.type = "full";
            this.forceSync.date = null;
            this.forceSync.isSpecificEntities = false;
            app.getCompanyWiseEntities(args.rowData.id);
            modal.Open('force-sync-modal');
            break;
          case 'Authenticate Fortnox':
            appInsights.trackEvent({
              name: 'AuthenticateFortnox',
              properties: {
                companyId: args.rowData.id
              }
            });
            agent.get<SyncResponse>(`v1/FortnoxActivation/GetFortnoxActivationToken/${args.rowData.id}`).then((response) => {
              if (response.result) {
                appInsights.trackEvent({
                  name: 'AuthenticateFortnox',
                  properties: {
                    companyId: args.rowData.id
                  }
                });
                window.location.href = response.result.data;
                this.$router.push({ path: this.$route.path, query: { sid: 'sid' } })
              }
            }).catch(() => { });
            break;
          default: break;
        }
      }
    },
    prepareCompanyModalEditView() {
      const scopes = this.form.scope ? this.form.scope.split(' ') : [];
      const entities = this.form.entitiesSelectedForSync ? this.form.entitiesSelectedForSync.split(' ') : [];

      // Combine and filter unique non-empty values
      this.scopeTreeSelectedNodes = [...new Set([...scopes, ...entities])].filter(id => id && id.trim() !== '');

      this.collapseTree();
    },

    getTreeView() {
      return this.$refs.treeView as any;
    },

    collapseTree() {
      this.$nextTick(() => {
        const tree = this.getTreeView();
        if (tree) {
          tree.collapseAll();
        }
      });
    },

    forceSyncByDate() {
      const params = {
        companyId: this.forceSync.companyId,
        subscriptionId: this.userStore.userInfo.subscriptionId,
        isFullSync: this.forceSync.type === 'full' ? true : false,
        forceSyncDate: this.forceSync.type === 'full' ? null : moment(this.forceSync.date).format("YYYY-MM-DD"),
        isSpecificEntities: this.forceSync.isSpecificEntities,
        entities: this.forceSync.isSpecificEntities ? this.forceSync.entities : []
      };

      if (params.isSpecificEntities && params.entities.length === 0) {
        toasterService.warn("Please select at least one entity to sync.");
        return;
      }
      console.log(params);

      preLoader.show();
      agent.post<SyncResponse>(`v1/Company/FortnoxSync`, params).then((response) => {
        if (response.result) {
          modal.Close('force-sync-modal');
          toasterService.success(response.result.message);
          preLoader.hide();
        }
      }).catch(() => {
        preLoader.hide();
        modal.Close('force-sync-modal');
      });
    },
    open() {
      this.isUpdate = false;
      this.scopeTreeSelectedNodes = this.treeViewData.filter(
        node =>
          this.defaultTreeViewOptions.find(opt => opt === node.id)
          || this.defaultTreeViewOptions.find(opt => opt === node.pid)
      ).map(node => node.id);

      this.treeViewData = this.treeViewData.map(node => {
        if (this.defaultTreeViewOptions.find(opt => opt === node.id)
          || this.defaultTreeViewOptions.find(opt => opt === node.pid)) {
          return { ...node, isChecked: true };
        }
        else {
          return { ...node, isChecked: false };
        }
      }
      );

      modal.Open('companyModal');
      this.disableTreeViewNodes();
      this.collapseTree();
    },
    nodeChecking(args: any) {
      if (args.action == 'uncheck' && args.node.dataset.uid == 'settings') {
        args.cancel = true;
        // In custom component validation logic, we might need to revert the change if we can't cancel.
        // But for now, CustomTreeView respects 'cancel' in the emitted event object if modified synchronously?
        // Actually, my implementation of CustomTreeView checks `args.cancel` after emit.
        // So setting args.cancel = true here works!
        return;
      }
    },
    disableTreeViewNodes() {
      this.disabledNodes = ['CompanySetting'];
    },
    close() {
      this.resetCompany();
      this.formKey++; // Increment formKey to force re-render

      const legalEntityDropDown: any = this.$refs.legalEntityDropDown;

      if (legalEntityDropDown) {
        legalEntityDropDown.ej2Instances.value = null;
      }

      modal.Close('companyModal');
    },
    closeForceSyncModal() {
      modal.Close('force-sync-modal');
    },
    filterCommandsBasedOnModule() {
      if (hasFortnox()) {
        return this.commands;
      }
      return this.commands.filter(c => ['Edit', 'Delete'].includes(c.type));
    },
    checkScopeChanged(existingScope: string, newScope: string) {
      const existingScopes = existingScope.split(' ').map(s => s.toLowerCase());
      const newScopes = newScope.split(' ').map(s => s.toLowerCase());

      if (existingScopes.length !== newScopes.length) {
        return true;
      }

      return !existingScopes.every(s => newScopes.includes(s));
    },
    getFormattedSwedishDatetime(date: string) {
      if (date) {
        const formattedUtcDateStr = date.replace(' ', 'T') + 'Z';

        const utcDate = new Date(formattedUtcDateStr);

        const swedishDate = utcDate.toLocaleString('sv-SE', {
          timeZone: 'Europe/Stockholm'
        });

        return moment(swedishDate).format("YYYY-MM-DD hh:mm A");
      }
      return "";
    },
    getRelativeSwedishDatetime(date: string) {
      if (date) {
        const formattedUtcDateStr = date.replace(' ', 'T') + 'Z';

        const utcDate = new Date(formattedUtcDateStr);

        // Convert UTC to browser local date
        const localDate = new Date(utcDate.toLocaleString('sv-SE', {
          timeZone: 'Europe/Stockholm'
        }));

        // Use moment to get relative time from now
        return moment(localDate).fromNow(); // e.g., "3 hours ago", "2 days ago"
      }
      return "";
    },
    showAlert() {
      this.alert = {
        show: false,
        messages: []
      };
      var expiredCompanies = this.data.result.filter((item: Company) => {
        return item.isRefreshTokenExpire;
      });
      if (expiredCompanies && expiredCompanies.length > 0) {
        this.alert.show = true;
        this.alert.messages.push("Token expired for " + expiredCompanies.length + " companies");
      }

      var scopeNotAppliedCompanies = this.data.result.filter((item: Company) => {
        return item.isScopeChangeApplied === false;
      });
      if (scopeNotAppliedCompanies && scopeNotAppliedCompanies.length > 0) {
        this.alert.show = true;
        this.alert.messages.push("Scope change not applied for " + scopeNotAppliedCompanies.length + " companies.");
      }

      var tokenMissingCompanies = this.data.result.filter((item: Company) => {
        return item.isTokenMissing === true;
      });
      if (tokenMissingCompanies && tokenMissingCompanies.length > 0) {
        this.alert.show = true;
        this.alert.messages.push("Token is missing for " + tokenMissingCompanies.length + " companies.");
      }
    },
    activateFortnox() {
      const app = this;
      appInsights.trackEvent({
        name: "AuthenticateFortnox",
        properties: { redirectUrl: location.href, queryString: location.search, timestamp: new Date().toISOString(), },
      });
      //handle if code, state or sid is missing in query string
      let params = this.split(location.search);
      if (params.isSuccess === false) {
        let error = ("error" in params) ? params.error : undefined;
        let errorDescription = ("errorDescription" in params) ? params.errorDescription : undefined;

        this.$router.replace('/company');
        this.loadCompany(this.initState(this.pageSettings.skip, this.pageSettings.take));
        toasterService.error(`Cannot get code from Fortnox. Error: ${errorDescription?.replace(/\+/g, ' ') || 'Please contact support.'}`,6500);
      } else if (params.isSuccess === true) {
        agent.get<FortnoxActivationResponse>(`v1/fortnoxactivation/activatefortnox`, params).then((response) => {
          if (response.result) {
            if (response.result.isSuccess) {
              this.$router.replace('/company');
              toasterService.success(this.$t("msgSave"));
              this.loadCompany(this.initState(this.pageSettings.skip, this.pageSettings.take));
            } else {
              if (response.result.data > 0) {
                Confirmation = DialogUtility.confirm({
                  title: this.$t("confirmation"),
                  content: response.result.error,
                  okButton: {
                    text: this.$t("yes"),
                    click: async function () {
                      Confirmation.hide();
                      app.activeFortnoxConfirmation(response.result.data, true);
                    },
                  },
                  cancelButton: {
                    text: this.$t("no"),
                    click: async function () {
                      Confirmation.hide();
                      app.activeFortnoxConfirmation(response.result.data, false);
                    }
                  },
                  showCloseIcon: false,
                  closeOnEscape: false,
                  zIndex: 10000,
                  animationSettings: { effect: "Zoom" },
                });
              } else {
                this.$router.replace('/company');
                toasterService.error(response.result.error);
                this.loadCompany(this.initState(this.pageSettings.skip, this.pageSettings.take));
              }
            }
          }
        });
      }
    },
    activeFortnoxConfirmation(stagingTokenId: number, isConfirmed: boolean) {
      const app = this;
      agent.get<FortnoxActivationResponse>(`v1/fortnoxactivation/confirm?stagingTokenId=${stagingTokenId}&isConfirmed=${isConfirmed}`).then((response) => {
        if (response.result) {
          if (response.result.isSuccess) {
            this.$router.replace('/company');
            app.loadCompany(app.initState(app.pageSettings.skip, app.pageSettings.take));
          } else {
            this.$router.replace('/company');
            toasterService.error(response.result.error);
            app.loadCompany(app.initState(app.pageSettings.skip, app.pageSettings.take));
          }
        }
      });
    },
    onForceSyncTypeChange(type: string) {
      this.forceSync.type = type;
    },
    getCompanyWiseEntities(companyId: number) {
      const params = {
        companyId: this.forceSync.companyId,
        subscriptionId: this.userStore.userInfo.subscriptionId,
      };

      agent.get<GetCompanyWiseEntitiesResponse>(`v1/company/getcompanywiseentities`, params).then((response) => {
        if (response.result) {
          this.entityLookUp.data = response.result.entities;
          this.forceSync.entities = response.result.selectedEntities;

          this.forceSync.type = response.result.isFullSync ? 'full' : 'custom';
          this.forceSync.isSpecificEntities = response.result.isSpecificEntities;
          this.forceSync.date = response.result.syncFrom;
        }
      }).catch(() => { });
    },
    openLegalEntityModal() {
      modal.Open('legalEntityManageModal');
    },
    closeLegalEntityModal() {
      modal.Close('legalEntityManageModal');
    },
    onSearch(searchText: string) {
      const grid = (this.$refs.gridCompany as any)?.ej2Instances;
      if (grid) grid.search(searchText);
    },
    clearSearch() {
      this.searchText = '';
      const grid = (this.$refs.gridCompany as any)?.ej2Instances;
      if (grid) grid.search('');
    }

  }
});
